import { useNavigate } from 'react-router-dom';
import {Container, Navbar, Nav, Row, Col}from 'react-bootstrap';

function Product(props){
    let navigate=useNavigate();
    return (
      <Col md={4}>
        <Nav.Link onClick={()=>{
          navigate('/detail/'+props.res[props.i])
        }}className="c1">
        <img src={props.shoes.imgUrl} width="80%" />
        <h4>{props.shoes.title}</h4>
        <p>{props.shoes.price}</p>
        </Nav.Link>
      </Col>
    )
  }

  export default Product;